// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.X6dgdO4fD4NggzT_77Wg {
  position: absolute;
  inset: 0;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}
.sSnMaXE03FmpG4dv4JCo {
  position: relative;
  width: 42px;
  height: 42px;
  margin: auto;
}
.sSnMaXE03FmpG4dv4JCo > svg {
  animation: SoxMUGlYsLh5W3Q9EmsY 2s infinite linear;
  color: #fff;
}
@keyframes SoxMUGlYsLh5W3Q9EmsY {
  100% {
    transform: rotate(360deg);
  }
}
@media screen and (max-width: 452px) {
  .Fg10FHTIuLmV2T_PfIGu {
    width: 100%;
    height: 100%;
  }
}
@media screen and (min-width: 453px) {
  .Fg10FHTIuLmV2T_PfIGu {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 30px;
  }
  .X6dgdO4fD4NggzT_77Wg {
    border-radius: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ScreenLoading/style.module.css"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AACJ;AAEA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAAJ;AAGA;EACI,kDAAA;EACA,WAAA;AADJ;AAIA;EACI;IACI,yBAAA;EAFN;AACF;AAMA;EACI;IACI,WAAA;IACA,YAAA;EAJN;AACF;AAOA;EACI;IACI,kBAAA;IACA,QAAA;IACA,SAAA;IACA,gCAAA;IACA,mBAAA;EALN;EAQE;IACI,mBAAA;EANN;AACF","sourcesContent":[".screen-loading-shadow {\n    position: absolute;\n    inset: 0;\n    align-items: center;\n    justify-content: center;\n    z-index: 1200;\n}\n\n.spin {\n    position: relative;\n    width: 42px;\n    height: 42px;\n    margin: auto;\n}\n\n.spin > svg {\n    animation: rotating 2s infinite linear;\n    color: #fff\n}\n\n@keyframes rotating {\n    100% {\n        transform: rotate(360deg)\n    }\n}\n\n\n@media screen and (max-width: 452px) {\n    .screen-loading {\n        width: 100%;\n        height: 100%;\n    }\n}\n\n@media screen and (min-width: 453px) {\n    .screen-loading {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        border-radius: 30px;\n    }\n\n    .screen-loading-shadow {\n        border-radius: 30px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen-loading-shadow": `X6dgdO4fD4NggzT_77Wg`,
	"spin": `sSnMaXE03FmpG4dv4JCo`,
	"rotating": `SoxMUGlYsLh5W3Q9EmsY`,
	"screen-loading": `Fg10FHTIuLmV2T_PfIGu`
};
export default ___CSS_LOADER_EXPORT___;
